import React from 'react';
import { IPayMethod } from 'models';
import { Grid } from '@mui/material';
import { client } from 'shared';
import { useUserContext } from 'UserContext';
import LoadingButton from 'reusableComponents/loadingButton';
import { EventAction } from 'parent-portal/shared/PublicSessionTracking';

export default function DefaultPaymentMethod({
    payMethod,
    setIdToDelete,
    setPayMethods,
    trackEvent,
}: {
    payMethod: IPayMethod;
    setIdToDelete: (n: number) => void;
    setPayMethods: React.Dispatch<React.SetStateAction<IPayMethod[]>>;
    trackEvent: (trackMessage: string, data?: object, action?: EventAction) => void;
}) {
    const { refreshUser } = useUserContext();

    const onDeleteClick = (payMethodId: number) => {
        setIdToDelete(payMethodId);
    };

    function setDefaultPayment(id: number) {
        setPayMethods((currentState: IPayMethod[]) => {
            return currentState.map((x) => {
                return {
                    ...x,
                    errorMessage: '',
                    isLoading: x.id === id,
                };
            });
        });

        client(`api/payment-info/${id}/default/`, { method: 'POST' })
            .then(() => {
                setPayMethods((currentState) => {
                    return currentState.map((x) => {
                        return {
                            ...x,
                            errorMessage: '',
                            isLoading: false,
                            is_default: x.id === id,
                        };
                    });
                });
                trackEvent('Payments: Set Default Payment', { payInfoId: id });
                refreshUser();
            })
            .catch(() => {
                setPayMethods((currentState) => {
                    return currentState.map((x) => {
                        return {
                            ...x,
                            errorMessage: x.id === id ? 'An error occurred updating your payment method' : '',
                            isLoading: false,
                        };
                    });
                });
            });
    }
    return (
        <Grid xs={12} md={6} container direction="row" justifyContent="space-between">
            <LoadingButton
                loading={payMethod.isLoading}
                onClick={() => onDeleteClick(payMethod.id)}
                asSecondary={true}
                buttonStyle={{ padding: '0.25em', margin: '0.25em', minWidth: 0, width: 100 }}
            >
                Delete
            </LoadingButton>
            <LoadingButton
                loading={payMethod.isLoading}
                onClick={() => setDefaultPayment(payMethod.id)}
                buttonStyle={{ padding: '0.25em 1em', margin: '0.25em', minWidth: 0, width: 'unset' }}
            >
                Make Default
            </LoadingButton>
        </Grid>
    );
}
